import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class OwnerInformationModel {

    firstName: string;
    lastName: string;
    phoneNumber: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    fullAddress: string;
    partyId: string;
    originalOwnerPartyId: string;

    constructor(model?: Partial<OwnerInformationModel>) {
        if (model && model !== undefined) {
          const def = new OwnerInformationModel();
          Object.keys(def).forEach((key: string) => {
            this[key] = model[key] && model[key] !== undefined ?
              model[key] : def[key];
          });
        }
    }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            firstName: [],
            lastName: [],
            phoneNumber: [],
            address1: [],
            address2: [],
            city: [],
            state: [],
            zip: [],
            fullAddress: [],
            partyId: [],
            originalOwnerPartyId: []
        });
    }

    static generateForm(fb: FormBuilder, model: OwnerInformationModel): FormGroup {
        if (model) {
            const form = OwnerInformationModel.asForm(fb);
            form.setValue(model);
            return form;
        }
    }

    static convertFormToModel(form: FormGroup): OwnerInformationModel {
        return form.value;
    }

}